import { setUserData } from 'app/dux/session/actionCreators';
import { isAuthenticated } from 'app/dux/session/selectors';
import { AppState } from 'app/store/reducers';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
    isAuthenticated: isAuthenticated(state)
});

const mapDispatchToProps = {
    setUserData,
};

export const connector = connect(mapStateToProps, mapDispatchToProps);
